module.exports = __webpack_public_path__ + "static/img/21.6571d1c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/5/zh/21.png
// module id = HsSq
// module chunks = 0